import { CircularProgress, Typography } from '@mui/material'
import { useCountdown } from '../../../../sharedComponents/src/hooks/useCountdown'
import { useScreenSize } from '../../../../sharedComponents/src/hooks/useScreenSize'
import { useStoreState } from '../../../../store/hooks'

export const WeeklyCountdown = () => {
    const { isMobile } = useScreenSize()
    const { nextResetAt } = useStoreState((state) => state.missionsService)

    const nextResetCountdown = useCountdown(nextResetAt, undefined)

    if (!nextResetAt) {
        return (
            <Typography textAlign="center" textTransform="uppercase" variant={isMobile ? 'h6' : 'h5'}>
                No missions available at the moment. <br />
                Please check back later.
            </Typography>
        )
    }

    if (!nextResetCountdown) {
        return <CircularProgress sx={{ m: '0 auto' }} size={48} color="primary" />
    }

    return (
        <Typography textAlign="center" variant={isMobile ? 'h6' : 'h5'}>
            ALL MISSIONS COMPLETED! <br />
            <br />
            New missions available in{' '}
            <Typography
                sx={{ fontVariantNumeric: 'tabular-nums' }}
                variant={isMobile ? 'h6' : 'h5'}
                component="span"
                color="secondary"
            >
                {nextResetCountdown}
            </Typography>
        </Typography>
    )
}
